import { IconChevronLeft16, IconChevronRight16 } from '@cian/ui-kit';
import * as React from 'react';
import { TDirection } from '@cian/frontend-newbuilding-carousel-component';
import classNames from 'classnames';
import * as styles from './Arrow.css';

interface IArrowProps {
  direction: TDirection;
  disabled: boolean;
  clickHandler?(direction: TDirection): void;
}

export const Arrow: React.FC<IArrowProps> = props => {
  const { direction, disabled, clickHandler } = props;

  return (
    <div
      className={classNames(styles['click_area'], direction < 0 && styles['click_area--left'])}
      onClick={() => {
        return clickHandler && !disabled && clickHandler(direction);
      }}
    >
      <div className={classNames(styles['background'], disabled && styles['click_area--disabled'])}>
        <div className={styles['icon_container']}>
          {direction < 0 ? (
            <IconChevronLeft16 color={'gray_icons_100'} />
          ) : (
            <IconChevronRight16 color={'gray_icons_100'} />
          )}
        </div>
      </div>
    </div>
  );
};
